import { connect } from 'react-redux';
let logo = '/images/logo.png'
import { Form, Button, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import i18n from 'config/i18n'
import { useState } from 'react';
import { UserServices } from 'services/index';
import { toast } from 'components/common/Toast'

const Support = (props) => {
  const { t } = useTranslation('live', { i18n })
  const [isLoading, setIsLoading] = useState(false)
  const [inputValues, setInputValues] = useState({
    content: ''
  })

  const handleOnChange = event => {
    const value = event.target.value
    const id = event.target.id
    setInputValues({ ...inputValues, [id]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    let isSuccess = await UserServices.support(inputValues)

    if (isSuccess) {
      toast.success(t('Message has been sent successfully'))
    }
    
    setInputValues({
      content: ''
    })

    setIsLoading(false)
  }

  return (
    <div className="main-content__support">
      <div className="support__container">
        <div className="container__logo  my-3">
          <img className="logo__image" src={logo} />
        </div>
        <Form className='container__form-wrapper' onSubmit={handleSubmit}>
          <Form.Group controlId='content'>
            <Form.Label>{t('Content')}:</Form.Label>
            <Form.Control
              onChange={handleOnChange}
              value={inputValues.content}
              as='textarea'
              rows={10}
              style={{ height: 'initial' }}
              type='text' />
          </Form.Group>
          <Button variant='primary' type='submit' size='lg' className='form__button'
            disabled={isLoading || !inputValues.content}>
            {isLoading ? <Spinner
              as='span' animation='border' size='md' role='status'
            /> : t('Send')}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default connect(null)(Support);
